import React from 'react';
import AlertCircleIcon from '@assets/icons/alert-circle.svg';
import { BaseAlertBanner } from '@components';
import { UploadStateInfo } from '@components/image-upload-modal/styled.tsx';

interface Props {
    message: string;
    description: string;
}
export const PhotoUploadFailure: React.FC<Props> = ({ message, description }) => {
    return (
        <BaseAlertBanner
            icon={<AlertCircleIcon />}
            type={'error'}
            title={message}
            description={<UploadStateInfo>{description}</UploadStateInfo>}
        />
    );
};
